<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="ml-3 mt-2">Reach</h2>
        <v-divider class="mt-2 mb-4" />
      </v-col>
      <v-col cols="4">
        <h3>Reach</h3>
        <h2 class="text-lg-right">{{metrics.reach}}K voters</h2>
        <v-slider
          :max="500"
          :min="0"
          :step="5"
          :value="metrics.reach"
          @change="setReach"
        />
      </v-col>
      <v-col cols="4">
        <h3>Frequency</h3>
        <h2 class="text-lg-right">{{metrics.frequency}}x</h2>
        <v-slider
          :value="metrics.frequency"
          :max="5.0"
          :min="0"
          :step=".1"
          @change="setFrequency"
        />
      </v-col>
      <v-col cols="4">
        <h3>Touchpoints (Impressions)</h3>
        <h2 class="text-lg-right">{{getFilter(impressions,"thousands")}}K</h2>
      </v-col>
      <v-col cols="12">
        <h2 class="ml-3 mt-2">Engagement</h2>
        <v-divider class="mt-2 mb-4" />
      </v-col>
      <v-col cols="4" />
      <v-col cols="4">
        <h3>Engagement rate (CTR)</h3>
        <h2 class="text-lg-right">{{getFilter(metrics.ctr,"percent")}}</h2>
        <v-slider
          :value="metrics.ctr"
          :max="4"
          :min="0"
          :step=".1"
          @change="setCtr"
          />
      </v-col>
      <v-col cols="4">
        <h3>Voter engagements</h3>
        <h2 class="text-lg-right">{{getFilter(clicks,"thousands")}}K</h2>
      </v-col>
      <v-col cols="12">
        <h2 class="ml-3 mt-5">Budget</h2>
        <v-divider class="mt-2 mb-4" />
      </v-col>
      <v-col cols="4" />
      <v-col cols="4">
        <h3>Cost per Impression (CPM)</h3>
        <h2 class="text-lg-right">{{getFilter(metrics.cpm,"currency")}}</h2>
        <v-slider
          :value="metrics.cpm"
          :max="20.0"
          :min="0"
          :step=".1"
          @change="setCpm"
          />
      </v-col>
      <v-col cols="4">
        <h3>Budget</h3>
        <h2 class="text-lg-right">{{getFilter(budget,"currency")}}</h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'goals-calculation-block',
    props: {
      metrics: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      impressions () {
        return this.metrics.reach * this.metrics.frequency
      },
      clicks () {
        return this.impressions * this.metrics.ctr / 100
      },
      budget () {
        return this.impressions * this.metrics.cpm
      }
    },
    methods: {
      setReach (number) {
        this.$emit('updateMetric', 'reach', number)
      },
      setFrequency (number) {
        this.$emit('updateMetric', 'frequency', number)
      },
      setCtr (number) {
        this.$emit('updateMetric', 'ctr', number)
      },
      setCpm (number) {
        this.$emit('updateMetric', 'cpm', number)
      },
      getFilter (number, filter) {
        if (filter === 'thousands') {
          return Number(number).toLocaleString()
        } else if (filter === 'currency') {
          return '$' + Number(number).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
        } else if (filter === 'percent') {
          return parseFloat(number).toFixed(1) + '%'
        } else if (filter === 'campaignType') {
          return number.substr(3)
        } else return number
      }
    }
  }
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
